import { gsap } from 'gsap';
import KeenSlider from 'keen-slider';

const sliderInstances = new WeakMap();

const modalInfoIcons = {
  stethoscope: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 4v5a4 4 0 0 0 8 0V4M10 13v4a4 4 0 0 0 8 0v-2" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/><circle cx="19" cy="13" r="2.2" stroke="currentColor" stroke-width="1.8"/></svg>',
  map: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M3 7l6-3 6 3 6-3v13l-6 3-6-3-6 3V7zM9 4v13M15 7v13" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>',
  calendar: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><rect x="3" y="5" width="18" height="16" rx="2.5" stroke="currentColor" stroke-width="1.8"/><path d="M3 10h18M8 3v4M16 3v4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>',
  participants: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="8" cy="9" r="3" stroke="currentColor" stroke-width="1.8"/><circle cx="16.5" cy="10" r="2.5" stroke="currentColor" stroke-width="1.8"/><path d="M3.5 19a5 5 0 0 1 9 0M13 19a4 4 0 0 1 7 0" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>',
  specialists: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="7.5" r="3" stroke="currentColor" stroke-width="1.8"/><path d="M6.5 19a5.5 5.5 0 0 1 11 0M4 13h3M17 13h3M8.5 13h7" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>',
  pin: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 21s6-5.4 6-11a6 6 0 1 0-12 0c0 5.6 6 11 6 11Z" stroke="currentColor" stroke-width="1.8"/><circle cx="12" cy="10" r="2.3" stroke="currentColor" stroke-width="1.8"/></svg>',
  clock: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="8" stroke="currentColor" stroke-width="1.8"/><path d="M12 8v4l2.8 2" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>',
  building: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 20V5h10v15M14 10h6v10M7 8h1M10 8h1M7 11h1M10 11h1M7 14h1M10 14h1" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>',
  globe: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="8" stroke="currentColor" stroke-width="1.8"/><path d="M4 12h16M12 4a13 13 0 0 1 0 16M12 4a13 13 0 0 0 0 16" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>',
  star: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="m12 4 2.4 4.8 5.3.8-3.8 3.7.9 5.3-4.8-2.5-4.8 2.5.9-5.3-3.8-3.7 5.3-.8L12 4Z" stroke="currentColor" stroke-width="1.8"/></svg>',
  heart: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 20s-7-4.5-7-9.8A4.2 4.2 0 0 1 9.3 6c1.3 0 2.2.6 2.7 1.4.5-.8 1.4-1.4 2.7-1.4a4.2 4.2 0 0 1 4.3 4.2C19 15.5 12 20 12 20Z" stroke="currentColor" stroke-width="1.8"/></svg>',
  check: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="8" stroke="currentColor" stroke-width="1.8"/><path d="m8.7 12 2.2 2.2 4.4-4.4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>',
  shield: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 3 5 6v5c0 4.4 2.8 7.7 7 9 4.2-1.3 7-4.6 7-9V6l-7-3Z" stroke="currentColor" stroke-width="1.8"/></svg>',
  chart: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 19V5M5 19h14M9 15l3-3 2 2 4-5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>',
  microscope: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M8 19h10M10 5l2.5 2.5M8 9l3 3M12 7l2 2a4.5 4.5 0 0 1-6.4 6.4L6 13.8" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><path d="M13 13h4a3 3 0 0 1 0 6" stroke="currentColor" stroke-width="1.8"/></svg>',
  book: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 5.5A2.5 2.5 0 0 1 7.5 3H19v16H7.5A2.5 2.5 0 0 0 5 21V5.5Z" stroke="currentColor" stroke-width="1.8"/><path d="M5 18.5A2.5 2.5 0 0 1 7.5 16H19" stroke="currentColor" stroke-width="1.8"/></svg>',
  briefcase: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><rect x="3" y="7" width="18" height="12" rx="2" stroke="currentColor" stroke-width="1.8"/><path d="M9 7V5h6v2M3 12h18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>',
  users: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="9" cy="9" r="3" stroke="currentColor" stroke-width="1.8"/><circle cx="16.5" cy="9.5" r="2.5" stroke="currentColor" stroke-width="1.8"/><path d="M4 19a5 5 0 0 1 10 0M14 19a4 4 0 0 1 6 0" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>',
  speaker: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 13h4l5 4V7l-5 4H4v2Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><path d="M16 10a4 4 0 0 1 0 4M18 8a7 7 0 0 1 0 8" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>',
  ticket: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 8a2 2 0 0 0 2-2h12a2 2 0 0 0 2 2v3a2 2 0 0 0 0 4v3a2 2 0 0 0-2 2H6a2 2 0 0 0-2-2v-3a2 2 0 0 0 0-4V8Z" stroke="currentColor" stroke-width="1.8"/><path d="M10 9v6M14 9v6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>',
};

const updateButtonsState = (instance, prevButton, nextButton) => {
  if (!instance || !instance.track || !instance.track.details) {
    return;
  }

  const current = instance.track.details.rel;
  const maxIndex = instance.track.details.maxIdx;

  if (prevButton) {
    const isDisabled = current <= 0;
    prevButton.disabled = isDisabled;
    prevButton.setAttribute('aria-disabled', String(isDisabled));
  }

  if (nextButton) {
    const isDisabled = current >= maxIndex;
    nextButton.disabled = isDisabled;
    nextButton.setAttribute('aria-disabled', String(isDisabled));
  }
};

const initPreviousEventsSlider = (root) => {
  if (!root || sliderInstances.has(root)) {
    return;
  }

  const sliderElement = root.querySelector('.keen-slider');
  const sectionRoot = root.closest('.previous-events') || root;
  const prevButton = sectionRoot.querySelector('[data-previous-events-prev]');
  const nextButton = sectionRoot.querySelector('[data-previous-events-next]');

  if (!sliderElement) {
    return;
  }

  const totalSlides = sliderElement.querySelectorAll('.keen-slider__slide').length;

  if (totalSlides <= 1) {
    if (prevButton) {
      prevButton.disabled = true;
      prevButton.setAttribute('aria-disabled', 'true');
    }

    if (nextButton) {
      nextButton.disabled = true;
      nextButton.setAttribute('aria-disabled', 'true');
    }

    return;
  }

  const slider = new KeenSlider(sliderElement, {
    loop: false,
    rubberband: false,
    mode: 'snap',
    slides: {
      perView: 1,
      spacing: 0,
      origin: 'center',
    },
    breakpoints: {
      '(min-width: 768px)': {
        slides: {
          perView: 1,
          spacing: 0,
          origin: 'auto',
        },
      },
    },
    created(instance) {
      updateButtonsState(instance, prevButton, nextButton);
    },
    slideChanged(instance) {
      updateButtonsState(instance, prevButton, nextButton);
    },
    updated(instance) {
      updateButtonsState(instance, prevButton, nextButton);
    },
  });

  if (prevButton) {
    prevButton.addEventListener('click', () => slider.prev());
  }

  if (nextButton) {
    nextButton.addEventListener('click', () => slider.next());
  }

  sliderInstances.set(root, slider);
};

const initFeedbackSwitcher = (root) => {
  if (!root) {
    return;
  }

  const feedbackTextElement = root.querySelector('[data-feedback-text-target]');
  const feedbackAvatars = root.querySelectorAll('[data-feedback-avatar]');

  if (!feedbackTextElement || !feedbackAvatars.length) {
    return;
  }

  const avatarsContainer = feedbackAvatars[0].parentElement;

  const setActiveAvatar = (activeAvatarButton) => {
    if (!activeAvatarButton) {
      return;
    }

    feedbackAvatars.forEach((avatar) => {
      const isActive = avatar === activeAvatarButton;
      avatar.classList.toggle('is-active', isActive);
      avatar.setAttribute('aria-pressed', String(isActive));
    });

    if (avatarsContainer) {
      // Keep the active avatar closest to the feedback text bubble.
      avatarsContainer.appendChild(activeAvatarButton);
    }
  };

  const initialActive = root.querySelector('[data-feedback-avatar].is-active') || feedbackAvatars[0];
  setActiveAvatar(initialActive);

  feedbackAvatars.forEach((avatarButton) => {
    avatarButton.addEventListener('click', () => {
      const nextText = avatarButton.getAttribute('data-feedback-value') || '';
      if (nextText) {
        feedbackTextElement.textContent = nextText;
      }
      setActiveAvatar(avatarButton);
    });
  });
};

const initPreviousEventsModal = (sectionRoot) => {
  if (!sectionRoot) {
    return;
  }

  if (sectionRoot.dataset.previousEventsModalInit === 'true') {
    return;
  }

  const modal = sectionRoot.querySelector('[data-previous-event-modal]');
  const openButtons = sectionRoot.querySelectorAll('[data-previous-event-open-modal]');
  const closeButtons = sectionRoot.querySelectorAll('[data-previous-event-close-modal]');

  if (!modal || !openButtons.length) {
    return;
  }

  const modalTitle = modal.querySelector('[data-previous-event-modal-title]');
  const modalSubtitle = modal.querySelector('[data-previous-event-modal-subtitle]');
  const modalDescription = modal.querySelector('[data-previous-event-modal-description]');
  const modalImage = modal.querySelector('[data-previous-event-modal-image]');
  const modalLogo = modal.querySelector('[data-previous-event-modal-logo]');
  const modalInfo = modal.querySelector('[data-previous-event-modal-info]');
  const modalSecondaryImage = modal.querySelector('[data-previous-event-modal-secondary-image]');
  const modalBullets = modal.querySelector('[data-previous-event-modal-bullets]');
  const modalMetrics = modal.querySelector('[data-previous-event-modal-metrics]');
  const modalBannerImage = modal.querySelector('[data-previous-event-modal-banner-image]');
  const modalBannerText = modal.querySelector('[data-previous-event-modal-banner-text]');
  const modalBannerButton = modal.querySelector('[data-previous-event-modal-banner-button]');
  const modalBackdrop = modal.querySelector('.previous-events__modal-backdrop');
  const modalDialog = modal.querySelector('.previous-events__modal-dialog');
  const modalCloseButton = modal.querySelector('.previous-events__modal-close');
  const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let lenisWasStoppedByModal = false;
  let modalAnimation = null;

  const getModalInfoItems = () => (modalInfo ? Array.from(modalInfo.querySelectorAll('.previous-events__modal-info-item')) : []);
  const getModalMetricItems = () => (modalMetrics ? Array.from(modalMetrics.children) : []);
  const getModalBulletItems = () => (modalBullets ? Array.from(modalBullets.children) : []);
  const getInfoContainers = () => [modalInfo, modalMetrics, modalBullets, modalBannerButton].filter(Boolean);
  const getAnimatedElements = () => [
    modalTitle,
    modalSubtitle,
    modalDescription,
    modalImage,
    modalLogo,
    modalInfo,
    modalSecondaryImage,
    modalBullets,
    modalMetrics,
    modalBannerImage,
    modalBannerText,
    modalBannerButton,
  ].filter(Boolean);

  const pausePageScroll = () => {
    const lenis = window.rvLenis;
    if (lenis && typeof lenis.stop === 'function') {
      lenis.stop();
      lenisWasStoppedByModal = true;
    }
  };

  const resumePageScroll = () => {
    const lenis = window.rvLenis;
    if (lenisWasStoppedByModal && lenis && typeof lenis.start === 'function') {
      lenis.start();
    }
    lenisWasStoppedByModal = false;
  };

  const resetModalAnimationState = () => {
    gsap.killTweensOf([modal, modalBackdrop, modalDialog, modalCloseButton, ...getAnimatedElements(), ...getModalInfoItems(), ...getModalMetricItems(), ...getModalBulletItems()]);
  };

  const finishOpen = () => {
    modalAnimation = null;
  };

  const finishClose = () => {
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('previous-events-modal-open');
    resumePageScroll();
    modalAnimation = null;
  };

  const animateModalOpen = () => {
    resetModalAnimationState();

    if (prefersReducedMotion()) {
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('previous-events-modal-open');
      pausePageScroll();
      finishOpen();
      return;
    }

    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('previous-events-modal-open');
    pausePageScroll();

    gsap.set(modal, { autoAlpha: 1 });
    gsap.set(modalBackdrop, { opacity: 0 });
    gsap.set(modalDialog, { opacity: 0, y: 28, scale: 0.98, transformOrigin: '50% 12%' });
    gsap.set(modalCloseButton, { opacity: 0, y: -10 });
    gsap.set(getAnimatedElements(), { opacity: 0, y: 16 });
    gsap.set(getInfoContainers(), { opacity: 0 });
    gsap.set([...getModalInfoItems(), ...getModalMetricItems(), ...getModalBulletItems()], { opacity: 0, y: 12 });

    modalAnimation = gsap.timeline({
      defaults: { ease: 'power3.out' },
      onComplete: finishOpen,
    });

    modalAnimation
      .to(modalBackdrop, { duration: 0.22, opacity: 1 }, 0)
      .to(modalDialog, { duration: 0.32, opacity: 1, y: 0, scale: 1 }, 0)
      .to(modalCloseButton, { duration: 0.22, opacity: 1, y: 0 }, 0.08)
      .to([modalImage, modalTitle, modalInfo, modalSecondaryImage, modalMetrics, modalBannerImage].filter(Boolean), {
        duration: 0.26,
        opacity: 1,
        y: 0,
        stagger: 0.05,
      }, 0.12)
      .to([modalSubtitle, modalDescription, modalBullets, modalBannerText, modalBannerButton, modalLogo], {
        duration: 0.24,
        opacity: 1,
        y: 0,
        stagger: 0.04,
      }, 0.18)
      .to([...getModalInfoItems(), ...getModalMetricItems(), ...getModalBulletItems()], {
        duration: 0.22,
        opacity: 1,
        y: 0,
        stagger: 0.03,
      }, 0.2);
  };

  const animateModalClose = () => {
    if (modalAnimation) {
      modalAnimation.kill();
      modalAnimation = null;
    }

    if (prefersReducedMotion()) {
      finishClose();
      return;
    }

    resetModalAnimationState();

    modalAnimation = gsap.timeline({
      defaults: { ease: 'power2.in' },
      onComplete: finishClose,
    });

    modalAnimation
      .to(getAnimatedElements(), {
        duration: 0.16,
        opacity: 0,
        y: 8,
        stagger: 0.02,
      }, 0)
      .to(getInfoContainers(), {
        duration: 0.14,
        opacity: 0,
        y: 8,
      }, 0)
      .to([...getModalInfoItems(), ...getModalMetricItems(), ...getModalBulletItems()], {
        duration: 0.12,
        opacity: 0,
        y: 6,
        stagger: 0.02,
      }, 0)
      .to(modalCloseButton, { duration: 0.12, opacity: 0, y: -8 }, 0)
      .to(modalDialog, { duration: 0.22, opacity: 0, y: 16, scale: 0.98 }, 0.02)
      .to(modalBackdrop, { duration: 0.2, opacity: 0 }, 0.05);
  };

  const openModal = (button) => {
    if (!button) {
      return;
    }

    if (modalTitle) {
      modalTitle.textContent = button.getAttribute('data-modal-title') || 'Conheça o processo deste evento';
    }

    if (modalDescription) {
      modalDescription.textContent = button.getAttribute('data-modal-description') || '';
    }
    if (modalSubtitle) {
      modalSubtitle.textContent = button.getAttribute('data-modal-subtitle') || 'Pré-lançamento';
    }

    if (modalImage) {
      const imageSrc = button.getAttribute('data-modal-image') || '';
      if (imageSrc) {
        modalImage.setAttribute('src', imageSrc);
      }
      modalImage.setAttribute('alt', button.getAttribute('data-modal-image-alt') || '');
    }

    if (modalLogo) {
      const logoSrc = button.getAttribute('data-modal-logo') || '';
      if (logoSrc) {
        modalLogo.setAttribute('src', logoSrc);
      }
      modalLogo.setAttribute('alt', button.getAttribute('data-modal-logo-alt') || '');
    }

    if (modalSecondaryImage) {
      modalSecondaryImage.setAttribute('src', button.getAttribute('data-modal-secondary-image') || button.getAttribute('data-modal-image') || '');
      modalSecondaryImage.setAttribute('alt', button.getAttribute('data-modal-secondary-image-alt') || '');
    }

    if (modalInfo) {
      const category = button.getAttribute('data-modal-category') || '';
      const city = button.getAttribute('data-modal-city') || 'São Paulo';
      const days = button.getAttribute('data-modal-days') || '3 dias';
      const participants = button.getAttribute('data-modal-participants') || '850 participantes';
      const specialists = button.getAttribute('data-modal-specialists') || '42 especialistas';
      const iconCategory = button.getAttribute('data-modal-icon-category') || 'stethoscope';
      const iconCity = button.getAttribute('data-modal-icon-city') || 'map';
      const iconDays = button.getAttribute('data-modal-icon-days') || 'calendar';
      const iconParticipants = button.getAttribute('data-modal-icon-participants') || 'participants';
      const iconSpecialists = button.getAttribute('data-modal-icon-specialists') || 'specialists';

      const renderInfoItem = (iconKey, text) => `
        <span class="previous-events__modal-info-item">
          <span class="previous-events__modal-info-icon">${
            iconKey && iconKey.indexOf('fa-') !== -1
              ? `<i class="${iconKey}" aria-hidden="true"></i>`
              : (modalInfoIcons[iconKey] || modalInfoIcons.stethoscope)
          }</span>
          <span class="previous-events__modal-info-text">${text}</span>
        </span>
      `;

      modalInfo.innerHTML = `
        ${category ? renderInfoItem(iconCategory, category) : ''}
        ${renderInfoItem(iconCity, city)}
        ${renderInfoItem(iconDays, days)}
        ${renderInfoItem(iconParticipants, participants)}
        ${renderInfoItem(iconSpecialists, specialists)}
      `;
    }

    if (modalBullets) {
      let bullets = [];
      try {
        bullets = JSON.parse(button.getAttribute('data-modal-bullets') || '[]');
      } catch (e) {
        bullets = [];
      }
      modalBullets.innerHTML = bullets.map((text) => `<li>${text}</li>`).join('');
    }

    if (modalMetrics) {
      let metrics = [];
      try {
        metrics = JSON.parse(button.getAttribute('data-modal-metrics') || '[]');
      } catch (e) {
        metrics = [];
      }
      modalMetrics.innerHTML = metrics.slice(0, 4).map((metric) => {
        const value = metric.rv_previous_event_metric_value || '';
        const label = metric.rv_previous_event_metric_label || '';
        return `<div><strong>${value}</strong><span>${label}</span></div>`;
      }).join('');
    }

    if (modalBannerImage) {
      modalBannerImage.setAttribute('src', button.getAttribute('data-modal-banner-image') || button.getAttribute('data-modal-image') || '');
      modalBannerImage.setAttribute('alt', button.getAttribute('data-modal-banner-image-alt') || '');
    }
    if (modalBannerText) {
      modalBannerText.textContent = button.getAttribute('data-modal-banner-text') || 'Se você está pensando em organizar um evento científico, nosso time pode ajudar a estruturar o projeto desde o início.';
    }
    if (modalBannerButton) {
      modalBannerButton.setAttribute('href', button.getAttribute('data-modal-banner-button-url') || '#');
      const modalBannerButtonText = modalBannerButton.querySelector('[data-previous-event-modal-banner-button-text]');
      if (modalBannerButtonText) {
        modalBannerButtonText.textContent = button.getAttribute('data-modal-banner-button-text') || 'Planejar meu evento';
      } else {
        modalBannerButton.textContent = button.getAttribute('data-modal-banner-button-text') || 'Planejar meu evento';
      }
    }

    animateModalOpen();
  };

  const closeModal = () => {
    animateModalClose();
  };

  openButtons.forEach((button) => {
    button.addEventListener('click', () => openModal(button));
  });

  closeButtons.forEach((button) => {
    button.addEventListener('click', closeModal);
  });

  modal.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) {
      return;
    }

    if (target.matches('[data-previous-event-close-modal]')) {
      closeModal();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && modal.hidden === false) {
      closeModal();
    }
  });

  sectionRoot.dataset.previousEventsModalInit = 'true';
};

const bootstrapPreviousEventsSliders = () => {
  const sliders = document.querySelectorAll('[data-previous-events-slider]');
  if (!sliders.length) {
    return;
  }

  sliders.forEach((sliderRoot) => {
    const sectionRoot = sliderRoot.closest('.previous-events') || sliderRoot;
    initPreviousEventsSlider(sliderRoot);
    initPreviousEventsModal(sectionRoot);
    const slides = sliderRoot.querySelectorAll('.previous-events__slide');
    slides.forEach((slide) => initFeedbackSwitcher(slide));
  });
};

const destroyPreviousEventsSliders = () => {
  const sliders = document.querySelectorAll('[data-previous-events-slider]');

  sliders.forEach((sliderRoot) => {
    const instance = sliderInstances.get(sliderRoot);
    if (instance && typeof instance.destroy === 'function') {
      instance.destroy();
    }
    sliderInstances.delete(sliderRoot);
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootstrapPreviousEventsSliders);
} else {
  bootstrapPreviousEventsSliders();
}

window.addEventListener('beforeunload', destroyPreviousEventsSliders);
